module.exports = __webpack_public_path__ + "img/slider-2.4a5001b0.png";